<template>
  <div>
    <b-overlay
      class="generalLoading"
      :show="showOverlay"
      rounded="sm"
      z-index="9999"
    >
      <template #overlay>
        <div class="d-flex flex-column align-items-center">
          <b-spinner
            variant="success"
            label="Carregando"
            style="width: 5rem; height: 5rem; font-size: x-large"
          >
          </b-spinner>
          <span class="mt-3 font-weight-bolder" style="font-size: 20px"
            >Carregando...</span
          >
        </div>
      </template>
      <div v-if="hasToken && newUser === true">
        <div class="main-container">
          <div class="Pcontent">
            <!-- <h2>Layout Publico</h2> -->
            <router-view></router-view>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { isNewUser, store } from "@/store";
import { UtilsTS } from "@/utilsts";
export default {
  name: "NovoUsuarioLayoutComponent",
  mixins: [UtilsTS],
  data() {
    return {
      contentHeight: 0,
    };
  },
  computed: {
    showOverlay() {
      return store.blockScreen || store.forceQuit;
    },
    hasToken() {
      return store.token !== false && store.cpf !== "";
    },
    newUser() {
      let permissao = isNewUser();
      return permissao;
    },
  },
  methods: {},
};
</script>
<style></style>